function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7,27.8v5.4L1,22.4H50V6.2A6.325,6.325,0,0,0,43.4,0H6.3C2.6,0,0,2.2,0,5.9v5.9H36.6V6.4L49.3,17.2H0V32.1c0,3.7,2.7,7,6.3,7H19.7l11,10.8.1-10.8H43.3A6.616,6.616,0,0,0,50,32.5V27.7H13.7Z",
  fill: "#046eab"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.3,39.2H16l5.7-11.3H13.6v5.4L1,22.4H24.3l2.8-5.2H0V32.1C0,35.8,2.7,39.1,6.3,39.2Z",
  transform: "translate(0 0)",
  fill: "#1590cf"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M35.6,0H6.3C2.6,0,0,2.2,0,5.9v5.9H29.7Z",
  fill: "#1590cf"
});

var SvgNotificationHubs = function SvgNotificationHubs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49.9,
    viewBox: "0 0 50 49.9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotificationHubs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notification_hubs.a51dc07c.svg";
export { ForwardRef as ReactComponent };